import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MarcoTelefono } from '../componentes/MarcoTelefono.js';
import { useSesion } from '../contexto/Sesion.js';
import { ErrorApi } from '../api/cliente.js';

export function LoginMedico() {
  const { loginMedico } = useSesion();
  const navegar = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      await loginMedico(email, password);
      navegar('/medico');
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setCargando(false);
    }
  }

  return (
    <MarcoTelefono>
      <div className="contenido" style={{ paddingTop: 28 }}>
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <div className="logo" style={{ width: 48, height: 48, borderRadius: 14, background: 'var(--verde)', color: 'var(--verde-claro)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>🩺</div>
          <h2 style={{ marginTop: 10 }}>Ausentia</h2>
          <p className="mini" style={{ margin: '-4px 0 8px' }}>by AtuelSoft</p>
          <p className="muted">Ingreso del médico auditor</p>
        </div>
        <form onSubmit={enviar}>
          <div className="campo">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          </div>
          <div className="campo">
            <label>Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </div>
          {error && <div className="error-box">{error}</div>}
          <button className="primario" disabled={cargando}>
            {cargando ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>
        <div className="aviso-info" style={{ marginTop: 16 }}>
          <span>🔐</span>
          <span>En producción: MFA + desbloqueo biométrico local (HU-01). En la demo, usuario y contraseña.</span>
        </div>
      </div>
    </MarcoTelefono>
  );
}
